
import { useCallback } from "react";
import { supabase } from "@/lib/supabase";
import { Profile } from "./types";

export const useProfileFetching = () => {
  const fetchProfile = useCallback(async (userId: string): Promise<Profile | null> => {
    console.log('Fetching profile for userId:', userId);
    
    // Get profile data from profiles table
    const { data: profileData, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
      
    if (error) {
      console.error("Error fetching profile:", error);
      return null;
    }
    
    console.log('Profile data fetched:', profileData);
    
    // Get user email from current session
    const { data: { user } } = await supabase.auth.getUser();
    
    // Create a properly typed profile object
    const profile: Profile = {
      ...(profileData as any),
      subscription_tier: profileData?.subscription_tier === 'pro' ? 'pro' : 'free'
    };
    
    // Add email from auth user data if available
    if (user?.email) {
      profile.email = user.email;
    }
    
    console.log('Final profile object:', profile);
    
    return profile;
  }, []);

  return { fetchProfile };
};
